<div class="page-wrapper product-comparator-page">
    <div class="wrap-breadcrumb">
        <div class="container">
            <div class="breadcrumb">
                <div>
                    <a style="margin-right: 2px" routerLink="/">{{
                        'IRONSIDE.product-comparator.HOME' | translate
                    }}</a>
                    > {{ 'IRONSIDE.product-comparator.PRODUCT_COMPARATOR' | translate }}
                </div>
            </div>
        </div>
    </div>
    <div class="product-comparator-page-inner">
        <div class="container">
            <h2 class="title d-flex align-items-center gap-2">
                <img src="src-/assets/images/icon/comparator.svg" alt="" />
                {{ 'IRONSIDE.product-comparator.PRODUCT_COMPARATOR' | translate }}
            </h2>
        </div>
        <div>
            <div class="container">
                <div class="py-4 general-info wrap-block d-flex flex-wrap">
                    <div *ngFor="let product of listProducts" class="block item">
                        <div class="wrap-img-text">
                            <div class="wrap-img text-center">
                                <img
                                    [src]="
                                        product?.urlImage
                                            ? product.urlImage
                                            : 'src-ironside/assets/images/image-default.jpg'
                                    "
                                    alt=""
                                />
                            </div>

                            <div class="wrap-text">
                                <a
                                    (click)="navigateToProduct(product.referenceProduct)"
                                    class="title"
                                    >{{ product?.shortDescription?.fr_FR }}</a
                                >
                                <p>
                                    {{ 'IRONSIDE.product-comparator.BRAND' | translate }}:
                                    <span>{{ product?.brand ? product?.brand?.value : '-' }}</span>
                                </p>
                                <p>
                                    {{ 'IRONSIDE.product-comparator.PACKAGING' | translate }}:
                                    <span>{{ product?.packaging?.[0]?.labels?.fr_FR }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="py-4 features">
                <div class="container">
                    <p class="title text-center">CARACTÉRISTIQUES DU PRODUIT</p>
                    <div class="wrap-block d-flex flex-wrap">
                        <div *ngFor="let item of listProducts" class="block">
                            <p>
                                Pays de fabrication :
                                <span>{{ item?.countryOfManufacture?.value }}</span>
                            </p>
                            <div class="group-logo d-flex">
                                <div class="group-logo d-flex gap-2 mb-2 flex-wrap">
                                    <ng-container
                                        *ngFor="let imgSusDev of listImageSustainableDevelopments"
                                    >
                                        <div
                                            *ngIf="displayImgSusDev(imgSusDev, item?.[imgSusDev.field])"
                                            class="wrap-logo text-center"
                                        >
                                            <img
                                                class="mb-0"
                                                style="
                                                    width: 80px;
                                                    height: 80px;
                                                    object-fit: contain;
                                                "
                                                [src]="imgSusDev?.urlImage"
                                                width="80"
                                                alt=""
                                                [title]="imgSusDev?.label ?? ''"
                                            />
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="container">
                <div class="py-4 package">
                    <p class="title text-center">CONDITIONNEMENT D'ACHAT</p>
                    <div class="wrap-block d-flex flex-wrap">
                        <div *ngFor="let item of listProducts" class="block">
                            <p>Désignation conditionnement primaire : <span>{{item?.primaryPackagingDesignation}}</span>
                            </p>
                            <p>Désignation conditionnement secondaire :
                                <span>{{item?.secondaryPackagingDesignation}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="py-4 price" *ngIf="userService.hasExtranetAccess('fonctions', 'catalogue-tarifs')">
                <div class="container">
                    <p class="title text-center">TARIFICATION</p>
                    <div class="wrap-block d-flex flex-wrap">
                        <div *ngFor="let item of listProducts" class="block">
                            <p>TGAP : <span>{{item?.tgap ? item?.tgap : '-'}} €</span></p>
                            <p>DEE : <span>{{item?.deee ? item?.deee : '-'}}</span></p>
                            <p class="text-blue mb-0"> {{ item?.price ? item?.price :
                                '-'
                                }}
                                € HT</p>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>
